<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}基础数据`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="800px"
        :before-close="close">
        <el-form ref="form" :model="form" label-width="120px" >
            <el-form-item label="基础数据标题" v-check="{
                '必填': !form.title,
            }">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="基础数据内容" ><!-- 不必提超哥说学校可以设置空 -->
                <el-input v-model="form.value"></el-input>
            </el-form-item>
            <el-form-item label="官网跳转参数">
                <el-input v-model="form.linkUrl"></el-input>
            </el-form-item>
            <div class="edit_form fx fx-m_center" style="width: 800px">
                <span style="margin-left:-0px;">图片</span>
                <div style="width: 200px;margin-left:15px;">
                    <el-upload
                        v-loading="uploading"
                        element-loading-text="上传中..."
                        class="photo_uploader "
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="upload">
                        <img v-if="form.url != null" :src="form.url" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                </div>
                <div style="width: 200px">
                    <el-upload
                        v-loading="uploading1"
                        element-loading-text="上传中..."
                        class="photo_uploader "
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="upload1">
                        <img v-if="form.url1 != null" :src="form.url1" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                </div>
                <div>
                    <el-upload
                        v-loading="uploading2"
                        element-loading-text="上传中..."
                        class="photo_uploader "
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="upload2">
                        <img v-if="form.url2 != null" :src="form.url2" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                </div>
            </div>
            <span  class="fx fx-center" style="margin-top:30px;">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </el-form>

    </el-drawer>

</template>


<style scoped>
   .fx-c_stretch .pic_item {
        width: 40%;
        height: 200px;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;
    }
    .pic_item img {
        width: 100%;
        height: 100%;
    }
    .fx-c_stretch .del_btn {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 30px;
        color: rgb(22, 21, 21);
    }
    .del_btn:hover {
        color: var(--primary);
    }
    .upload_btn {
        border-radius: 10px;
        cursor: pointer;
    }
</style>
<script>


    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                uploading: false,
                uploading1: false,
                uploading2: false,
                form: {...this.item,type:2},
                articles: {},
                needRefreshParent: false,
                typeOption: [
                    {id:2,name:"基础数据"},
                    {id:3,name:"新闻分类"},
                ],
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        this.$ajaxPost("/dictionary/save", {
                            dictionary: this.form,
                        }, data => {
                            this.$showSuccess("保存成功", 1200, ()=> {
                                this.needRefreshParent = true;
                                this.$emit("submit", data.result);
                                this.$emit("close");
                            })
                        })
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })

            },

            selectChanged(params) {
                console.log(params.name)
                if(params != null){
                    this.form.value = params.name;
                }

            },

            articleSearch(query) {
                this.form.keywords = query;
                this.$ajaxPost("/articleType/listArticleType", {
                    form: {keywords:query}
                }, (data) => {
                    this.articles = data.result;
                })
            },
            upload(file) {
                this.uploading = true;
                this.$uploadQiniu(file, "basicData/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {url: file.url});
                            this.uploading = false;
                        }
                    }
                )
                return false;
            },
            upload1(file) {
                this.uploading1 = true;
                this.$uploadQiniu(file, "basicData/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {url1: file.url});
                            this.uploading1 = false;
                        }
                    }
                )
                return false;
            },
            upload2(file) {
                this.uploading2 = true;
                this.$uploadQiniu(file, "basicData/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {url2: file.url});
                            this.uploading2 = false;
                        }
                    }
                )
                return false;
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
        }


    }
</script>
